export default "\n\n<div class=\"mat-app-background basic-container\">\n  <app-sidenav></app-sidenav>\n  \n</div>\n\n"